// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import type { OperationOptions } from "@azure-rest/core-client";

/** Optional parameters. */
export interface SqlResourcesListSqlRoleAssignmentsOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface SqlResourcesDeleteSqlRoleAssignmentOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface SqlResourcesCreateUpdateSqlRoleAssignmentOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface SqlResourcesGetSqlRoleAssignmentOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface SqlResourcesListSqlRoleDefinitionsOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface SqlResourcesDeleteSqlRoleDefinitionOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface SqlResourcesCreateUpdateSqlRoleDefinitionOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface SqlResourcesGetSqlRoleDefinitionOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface SqlResourcesListSqlTriggersOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface SqlResourcesDeleteSqlTriggerOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface SqlResourcesCreateUpdateSqlTriggerOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface SqlResourcesGetSqlTriggerOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface SqlResourcesListSqlUserDefinedFunctionsOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface SqlResourcesDeleteSqlUserDefinedFunctionOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface SqlResourcesCreateUpdateSqlUserDefinedFunctionOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface SqlResourcesGetSqlUserDefinedFunctionOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface SqlResourcesListSqlStoredProceduresOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface SqlResourcesDeleteSqlStoredProcedureOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface SqlResourcesCreateUpdateSqlStoredProcedureOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface SqlResourcesGetSqlStoredProcedureOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface SqlResourcesRetrieveContinuousBackupInformationOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface SqlResourcesListSqlContainersOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface SqlResourcesDeleteSqlContainerOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface SqlResourcesCreateUpdateSqlContainerOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface SqlResourcesGetSqlContainerOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface SqlResourcesListClientEncryptionKeysOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface SqlResourcesCreateUpdateClientEncryptionKeyOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface SqlResourcesGetClientEncryptionKeyOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface SqlResourcesMigrateSqlContainerToManualThroughputOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface SqlResourcesMigrateSqlContainerToAutoscaleOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface SqlResourcesUpdateSqlContainerThroughputOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface SqlResourcesGetSqlContainerThroughputOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface SqlResourcesMigrateSqlDatabaseToManualThroughputOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface SqlResourcesMigrateSqlDatabaseToAutoscaleOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface SqlResourcesUpdateSqlDatabaseThroughputOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface SqlResourcesGetSqlDatabaseThroughputOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface SqlResourcesListSqlDatabasesOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface SqlResourcesDeleteSqlDatabaseOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface SqlResourcesCreateUpdateSqlDatabaseOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface SqlResourcesGetSqlDatabaseOptionalParams extends OperationOptions {}
